// Menu configuration by user roles
// Each group has a labelKey and array of items
// Items use labelKey for i18n translations resolved by SidebarGroup

export const operatorMenu = [
  {
    groupLabelKey: 'layout:sidebar.groups.main',
    items: [
      { path: '/', labelKey: 'layout:sidebar.menu.requests', icon: 'ClipboardIcon', badgeKey: 'ACTIVE_REQUESTS_COUNT' },
      { path: '/requisites', labelKey: 'layout:sidebar.menu.requisites', icon: 'CreditCardIcon', badgeKey: 'ACTIVE_CREDENTIALS_COUNT' },
    ],
  },
  {
    groupLabelKey: 'layout:sidebar.groups.finance',
    items: [
      { path: '/addbalance', labelKey: 'layout:sidebar.menu.balance', icon: 'WalletIcon' },
      { path: '/payouts', labelKey: 'PayOut', icon: 'BanknotesIcon', badgeKey: 'ACTIVE_PAYOUTS_COUNT', conditionalKey: 'HAS_PAYOUT_SETTINGS', badgeColorKey: 'PAYOUT_SETTINGS_ENABLED' },
    ],
  },
  {
    groupLabelKey: 'layout:sidebar.groups.analytics',
    items: [
      { path: '/penalties', labelKey: 'layout:sidebar.menu.penalties', icon: 'ShieldExclamationIcon' },
      { path: '/chartsop', labelKey: 'layout:sidebar.menu.charts', icon: 'ChartBarIcon' },
      { path: '/events', labelKey: 'layout:sidebar.menu.events', icon: 'DevicePhoneMobileIcon' },
    ],
  },
  {
    groupLabelKey: 'layout:sidebar.groups.info',
    items: [
      { path: '/news', labelKey: 'layout:sidebar.menu.news', icon: 'NewspaperIcon', badgeKey: 'UNREAD_NEWS_COUNT' },
      { path: '/regulation', labelKey: 'layout:sidebar.menu.regulation', icon: 'DocumentTextIcon', conditionalKey: 'HAS_REGULATION' },
    ],
  },
  {
    groupLabelKey: 'layout:sidebar.groups.system',
    items: [
      { path: '/settings', labelKey: 'layout:sidebar.menu.settings', icon: 'CogIcon', warningBadge: true },
    ],
  },
];

// Меню тимлидера
export const teamleadMenu = [
  {
    groupLabelKey: 'layout:sidebar.groups.team',
    items: [
      { path: '/team', labelKey: 'layout:sidebar.menu.team', icon: 'UsersIcon' },
      { path: '/team/create', labelKey: 'layout:sidebar.menu.createTrader', icon: 'UserPlusIcon' },
      { path: '/deposits', labelKey: 'layout:sidebar.menu.deposits', icon: 'ArrowsRightLeftIcon' },
    ],
  },
  {
    groupLabelKey: 'layout:sidebar.groups.main',
    items: [
      { path: '/', labelKey: 'layout:sidebar.menu.requests', icon: 'ClipboardIcon', badgeKey: 'ACTIVE_REQUESTS_COUNT' },
      { path: '/requisites', labelKey: 'layout:sidebar.menu.requisites', icon: 'CreditCardIcon', badgeKey: 'ACTIVE_CREDENTIALS_COUNT' },
    ],
  },
  {
    groupLabelKey: 'layout:sidebar.groups.finance',
    items: [
      { path: '/addbalance', labelKey: 'layout:sidebar.menu.balance', icon: 'WalletIcon' },
      { path: '/withdrawals', labelKey: 'layout:sidebar.menu.withdrawals', icon: 'BanknotesIcon' },
    ],
  },
  {
    groupLabelKey: 'layout:sidebar.groups.analytics',
    items: [
      { path: '/penalties', labelKey: 'layout:sidebar.menu.penalties', icon: 'ShieldExclamationIcon' },
      { path: '/team-stats', labelKey: 'layout:sidebar.menu.teamStats', icon: 'ChartBarIcon' },
    ],
  },
  {
    groupLabelKey: 'layout:sidebar.groups.info',
    items: [
      { path: '/news', labelKey: 'layout:sidebar.menu.news', icon: 'NewspaperIcon', badgeKey: 'UNREAD_NEWS_COUNT' },
      { path: '/regulation', labelKey: 'layout:sidebar.menu.regulation', icon: 'DocumentTextIcon', conditionalKey: 'HAS_REGULATION' },
    ],
  },
  {
    groupLabelKey: 'layout:sidebar.groups.system',
    items: [
      { path: '/bot-setup', labelKey: 'layout:sidebar.menu.botSetup', icon: 'CogIcon' },
      { path: '/settings', labelKey: 'layout:sidebar.menu.settings', icon: 'CogIcon', warningBadge: true },
    ],
  },
];

// Партнёрское меню отключено
export const partnerMenu = [];
